import { render, staticRenderFns } from "./__template.vue?vue&type=template&id=3c8e160a&"
import script from "./__template.vue?vue&type=script&lang=js&"
export * from "./__template.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports